import { useTranslation } from "react-i18next";

import { IVehicle } from "../../models/Vehicle";
import useJobsByVehicle from "../../data/useJobsByVehicle";
import Card from "../shared/Card/Card";
import LoadingWheel from "../shared/LoadingWheel";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import VehiclePartSummary from "../jobs/VehiclePartSummary";
import openInNewTab from "../../utils/openInNewTab";

export default function VehicleDismantlingCard({ vehicle }: { vehicle: IVehicle }) {
  const { t } = useTranslation("vehicles");
  const { jobs } = useJobsByVehicle(vehicle.id);

  const activeJobs = (jobs.data?.data ?? []).filter((job) => !job.deleted);
  const hasJob = activeJobs.length > 0;
  const primaryJobId = activeJobs[0]?.id;

  const jobPartCategories = activeJobs.flatMap((job) => job.jobPartCategories ?? []);

  return (
    <Card
      title={t("Dismantling")}
      bodyClassName="p-4"
      headerRight={
        <ButtonInput
          label={t("View Job")}
          isSubmit={false}
          disabled={!primaryJobId}
          onClick={(e: any) => {
            e?.stopPropagation?.();
            if (primaryJobId) openInNewTab(`/jobs/${primaryJobId}`);
          }}
          classes="!py-1 !px-3 !text-sm"
        />
      }
    >
      {jobs.isLoading ? (
        <LoadingWheel />
      ) : (
        <div className="space-y-4">
          <span
            className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ${
              hasJob ? "bg-green-100 text-green-700" : "bg-gray-100 text-gray-600"
            }`}
          >
            {hasJob ? t("Job created") : t("No job")}
          </span>

          <VehiclePartSummary jobPartCategories={jobPartCategories} />
        </div>
      )}
    </Card>
  );
}
